module.exports = __webpack_public_path__ + "static/devWeekWin.resized-b5db7aafdb10234ae2a750a60e866afa.jpg";